function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TABLE = 'rider';
var COLUMNS = ['id', 'name', 'serial_number', 'bmx_member_id'];

var Rider = /*#__PURE__*/function () {
  _createClass(Rider, null, [{
    key: "all",
    value: function all(storage) {
      return storage.all(Rider.TABLE).then(function (results) {
        return results.map(function (r) {
          return new Rider(r);
        });
      });
    }
  }]);

  function Rider(props) {
    _classCallCheck(this, Rider);

    _extends(this, props);
  }

  return Rider;
}();

Rider.TABLE = TABLE;
Rider.COLUMNS = COLUMNS;
export default Rider;